module.exports = __webpack_public_path__ + "img/am-4-of-july-2021-final.e8de6824.jpg";